import { SVGProps } from 'react';

export default function ArrowIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path d="M9 1.16602L5 5.16602L1 1.16602" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
